var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDice1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#B70000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55556 0H28.4444C29.3874 0 30.2918 0.374602 30.9586 1.0414C31.6254 1.70819 32 2.61256 32 3.55556V28.4444C32 29.3874 31.6254 30.2918 30.9586 30.9586C30.2918 31.6254 29.3874 32 28.4444 32H3.55556C2.61256 32 1.70819 31.6254 1.0414 30.9586C0.374602 30.2918 0 29.3874 0 28.4444V3.55556C0 2.61256 0.374602 1.70819 1.0414 1.0414C1.70819 0.374602 2.61256 0 3.55556 0ZM16 12.4444C15.057 12.4444 14.1526 12.819 13.4858 13.4858C12.819 14.1526 12.4444 15.057 12.4444 16C12.4444 16.943 12.819 17.8474 13.4858 18.5142C14.1526 19.181 15.057 19.5556 16 19.5556C16.943 19.5556 17.8474 19.181 18.5142 18.5142C19.181 17.8474 19.5556 16.943 19.5556 16C19.5556 15.057 19.181 14.1526 18.5142 13.4858C17.8474 12.819 16.943 12.4444 16 12.4444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice1);
export default __webpack_public_path__ + "static/media/dice_1.97e0444f5adfd120bba73c7d2ee6a2ff.svg";
export { ForwardRef as ReactComponent };